import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from "vue";
import { IMenuItem, IMenuMap } from "../types";
import Icon from "../../icon/index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'common-left-menu',
  props: {
    menus: null,
    activeRouteName: null
  },
  emits: ["clickMenu"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: "clickMenu", menu: IMenuItem): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  menus: IMenuItem[];
  activeRouteName: string;
}





const defaultOpeneds = ref<string[]>([]);

// 生成映射，以便对外抛出选中的菜单对象
const menuMap = computed<IMenuMap>(() => {
  const menuMap: IMenuMap = {};
  for (let i = 0; i < props.menus.length; i++) {
    const mItem = props.menus[i];
    if (mItem.children) {
      mItem.children.forEach((cMItem) => {
        if (cMItem.name) {
          menuMap[cMItem.name] = cMItem;
        }
      });
    } else {
      if (mItem.name) {
        menuMap[mItem.name] = mItem;
      }
    }
  }
  return menuMap;
});

watch(
  () => props.menus,
  () => {
    const allFirstNames: string[] = [];
    props.menus.forEach((item) => {
      if (item.name) {
        allFirstNames.push(item.name);
      }
    });
    defaultOpeneds.value = allFirstNames;
  },
  {
    immediate: true,
  }
);

// 选中菜单
function onMenuSelect(index: string) {
  const menuItem = menuMap.value[index];
  emits("clickMenu", menuItem);
}

return { __sfc: true,emits, props, defaultOpeneds, menuMap, onMenuSelect, Icon }
}

})